var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    class: 'text-' + _vm.position
  }, [_c('v-col', {
    staticClass: "d-block",
    attrs: {
      "offset": _vm.offset,
      "cols": _vm.size
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "color": "primary",
      "rounded": "",
      "depressed": "",
      "loading": _vm.isSelecting,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onButtonClick
    }
  }, [_vm.previewInsideButton && _vm.anexo && _vm.anexo.name ? _c('div', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-close-circle-outline ")]), _vm._v(" " + _vm._s(_vm.truncate(_vm.anexo.name)) + " ")], 1) : _c('div', [!_vm.onlyIcon ? _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-cloud-upload ")]) : _c('v-icon', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(" mdi-cloud-upload ")]), !_vm.onlyIcon ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 1)]), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "click": function ($event) {
        _vm.$refs.uploader.value = null;
      },
      "change": _vm.onFileChanged,
      "cancel": _vm.onFileChanged
    }
  })], 1)])]), _vm.showInfo ? _c('v-col', {
    staticClass: "d-block",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_vm._v(" Só poderá anexar arquivo no(s) formato(s): "), _c('strong', [_vm._v(_vm._s(_vm.formats))])]), _c('div', [_vm._v(" O tamanho do arquivo deverá ser no máximo de: "), _c('strong', [_vm._v(_vm._s(_vm.maxSize) + "MB")])]), _c('div', [_vm._v(" Só poderá ser anexado "), _c('strong', [_vm._v("01")]), _vm._v(" arquivo ")])]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }